import { BaseIcon } from "@dgs/core";
import { FC } from "react";
import styled from "styled-components";

const StyledIcon = styled(BaseIcon)`
	width: 16px;
	height: 16px;
`;
interface Props {
	hasParticipation: boolean;
	className?: string;
}

export const ParticipationStatusIcon: FC<Props> = ({ hasParticipation, className }) => {
	if (hasParticipation) {
		return <StyledIcon className={className} src="/how_to_reg.svg" />;
	} else {
		return <StyledIcon className={className} src="/person_off.svg" />;
	}
};
